// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Erwartungswert, ErwartungswertDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateErwartungswert(): (
  aufgabeId: string,
  unteraufgabeId: string,
  requestBody: ErwartungswertDaten
) => Promise<Erwartungswert> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, unteraufgabeId, requestBody) =>
      (await getAPI()).erwartungswerte.createErwartungswert({
        aufgabeId,
        unteraufgabeId,
        requestBody,
      }),
    [getAPI]
  );
}
